import { forwardRef } from 'react';
import type { ComponentPropsWithoutRef } from 'react';

export const PetPawIcon = forwardRef<SVGSVGElement, ComponentPropsWithoutRef<'svg'>>(function PetPawIcon(
  props,
  ref,
) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      fill="none"
      aria-hidden
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.25 16.5c0-1.52 1.68-2.75 3.75-2.75s3.75 1.23 3.75 2.75-1.68 3.25-3.75 3.25-3.75-1.52-3.75-3.25z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10 12c.33-.9 1.15-1.5 2-1.5s1.67.6 2 1.5"
      />
      <circle cx="6.75" cy="9" r="1.75" />
      <circle cx="10" cy="6.5" r="1.75" />
      <circle cx="14" cy="6.5" r="1.75" />
      <circle cx="17.25" cy="9" r="1.75" />
    </svg>
  );
});
